import { SVGProps } from "react";

const STIVue = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Vue" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path fill="#42b883" d="m64 140h148l44 77l44-77h148L256 473" /><path fill="#35495e" d="m141 140h71l44 77l44-77h71L256 340" /></svg>;

export { STIVue };